import { withManifest } from '@godaddy/gasket-hcs';
import PropTypes from 'prop-types';
import FooterRoot from './footer/src/Footer';

const Footer = withManifest(FooterRoot, { componentName: 'footer' });

Footer.propTypes = {
  urls: PropTypes.shape({})
};

export default Footer;
